export default "__VITE_PUBLIC_ASSET__5be55a18__"